export default "__VITE_ASSET__D6IU7sID__"